import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Swal from 'sweetalert2';
import Loading from 'react-simple-loading';

const Record = () => {
    const navigate = useNavigate();
    const [record, setRecord] = useState(null);
    const params = useParams();
    const [isBtn, setIsBtn] = useState(false);


    useEffect(() => {

        document.title = 'Roam Pays: Records';
        if (!localStorage.getItem('@roampays-user')) {
            navigate("/login")
        }
        axios.get(process.env.REACT_APP_API_URL + "/get-record/" + params.record_id, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        })
            .then(function (response) {
                if (response?.data?.status) {
                    setRecord(response?.data?.record);
                }

            })
            .catch(function (error) {
                if (error.status == 403) navigate("/login");
                Swal.fire({ icon: "error", title: "Error", text: error.message });
            });




    }, []);




    const removeRecord = () => {


        setIsBtn(true);
        axios.post(process.env.REACT_APP_API_URL + "/remove-record", {
            record_id: params.record_id,
            file_name: record?.file_name,
        }, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        })
            .then(function (response) {
                if (response?.data?.status) {

                    Swal.fire({ icon: "success", title: "Removed Successfully", text: "Your record has been removed successfully." });
                    navigate("/records");
                }
                setIsBtn(false)

            })
            .catch(function (error) {
                setIsBtn(false)
                Swal.fire({ icon: "error", title: "Error", text: error.message });

            });


    }


    const backToRecords = async (e) => {
        navigate("/records")
    };



    return (
        <>

            <div className="title-box">
                <div className="flex-equal justify-content-start " >
                    <button className="btn btn-link fs-12 d-flex fd-row align-items-center" onClick={backToRecords} >

                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.69765 6.99997L8.68205 4.01557L7.65085 2.98438L3.63525 6.99997L7.65085 11.0156L8.68205 9.98438L5.69765 6.99997Z" fill="white" />
                        </svg>
                        <label >Back</label>

                    </button>

                </div>
                <h3 className="flex-equal justify-content-center fs-32 fs-helvetica color-white">Records</h3>
                <div className="flex-equal justify-content-end" >
                    {record?.file_name &&
                        <a href={process.env.REACT_APP_API_URL + "/download-record/" + record?.record_id} target="_blank" className="btn btn-link fs-12 d-flex fd-row align-items-center" >

                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                <path d="M7.58333 7.92504L10.2998 5.20854L11.1248 6.0335L7 10.1583L2.87521 6.0335L3.70017 5.20854L6.41667 7.92504V1.75H7.58333V7.92504Z" fill="white" />
                                <path d="M2.91667 8.75V11.0833H11.0833V8.75H12.25V11.0833C12.25 11.7277 11.7277 12.25 11.0833 12.25H2.91667C2.27233 12.25 1.75 11.7277 1.75 11.0833V8.75H2.91667Z" fill="white" />
                            </svg>
                            <label>Download</label>

                        </a>
                    }
                </div>

            </div>


            <div className="box" >

                <div className="record-card-box" >

                    {record &&
                        <div className={record?.category == "certification" ? "record-card bg-yellow" : (record?.category == "license" ? "record-card bg-blue" : "record-card bg-red")} >
                            <div className="record-card-header" >
                                

                                        {record?.category == "license" &&

                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                <g clip-path="url(#clip0_6133_22669)">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.921 2.94633L12 1.84863L10.079 2.94633C8.87025 3.63706 7.50214 4.00038 6.10992 4.00038H4V11.1972C4 15.1446 6.11515 18.7894 9.54247 20.7478L12 22.1521L14.4575 20.7478C17.8849 18.7894 20 15.1446 20 11.1972V4.00038H17.8901C16.4979 4.00038 15.1297 3.63706 13.921 2.94633ZM11.4141 12.0004L9.99991 10.5862L8.58569 12.0004L11.4141 14.8288L15.6568 10.5862L14.2425 9.17194L11.4141 12.0004Z" fill="white" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_6133_22669">
                                                        <rect width="20" height="20" fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        }
                                        {record?.category == "certification" &&

                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M10.9591 2.89725C10.4294 2.36758 9.57062 2.36758 9.04095 2.89725L7.85842 4.07978C7.71777 4.22043 7.52701 4.29945 7.32809 4.29945H5.65575C4.90668 4.29945 4.29945 4.90668 4.29945 5.65575V7.32809C4.29945 7.52701 4.22043 7.71777 4.07978 7.85842L2.89725 9.04095C2.36758 9.57062 2.36758 10.4294 2.89725 10.9591L4.07978 12.1416C4.22043 12.2822 4.29945 12.473 4.29945 12.6719V14.3442C4.29945 15.0933 4.90668 15.7006 5.65575 15.7006H7.32809C7.52701 15.7006 7.71777 15.7796 7.85842 15.9202L9.04095 17.1027C9.57062 17.6324 10.4294 17.6324 10.9591 17.1027L12.1416 15.9202C12.2822 15.7796 12.473 15.7006 12.6719 15.7006H14.3442C15.0933 15.7006 15.7006 15.0933 15.7006 14.3443V12.6719C15.7006 12.473 15.7796 12.2822 15.9202 12.1416L17.1027 10.9591C17.6324 10.4294 17.6324 9.57062 17.1027 9.04095L15.9202 7.85842C15.7796 7.71777 15.7006 7.52701 15.7006 7.32809V5.65575C15.7006 4.90668 15.0933 4.29945 14.3442 4.29945H12.6719C12.473 4.29945 12.2822 4.22043 12.1416 4.07978L10.9591 2.89725ZM7.98029 1.83659C9.09574 0.721136 10.9043 0.721136 12.0197 1.83659L12.9826 2.79945H14.3442C15.9217 2.79945 17.2006 4.07826 17.2006 5.65575V7.01743L18.1634 7.98029C19.2789 9.09574 19.2789 10.9043 18.1634 12.0197L17.2006 12.9826V14.3443C17.2006 15.9217 15.9217 17.2006 14.3442 17.2006H12.9826L12.0197 18.1634C10.9043 19.2789 9.09574 19.2789 7.98029 18.1634L7.01743 17.2006H5.65575C4.07826 17.2006 2.79945 15.9217 2.79945 14.3442V12.9826L1.83659 12.0197C0.721137 10.9043 0.721136 9.09574 1.83659 7.98029L2.79945 7.01743V5.65575C2.79945 4.07826 4.07826 2.79945 5.65575 2.79945H7.01743L7.98029 1.83659ZM13.6767 6.13321C14.0173 6.36886 14.1024 6.83604 13.8668 7.17669L9.37017 13.6767C9.23285 13.8752 9.00838 13.9955 8.76705 13.9999C8.52571 14.0043 8.29701 13.8923 8.15254 13.6989L6.14917 11.0174C5.90125 10.6855 5.96928 10.2155 6.30112 9.96763C6.63295 9.71972 7.10292 9.78775 7.35083 10.1196L8.72997 11.9656L12.6332 6.32331C12.8689 5.98266 13.336 5.89755 13.6767 6.13321Z" fill="white" />
                                            </svg>
                                        }
                                        {record?.category == "vaccine" &&

                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M1.8277 4.94146C1.61277 5.1564 1.61277 5.50484 1.8277 5.71978C2.04262 5.93467 2.39107 5.93471 2.60599 5.71978L2.99539 5.33033L4.94089 7.27589L3.3843 8.83252C3.16936 9.04746 3.16936 9.3959 3.3843 9.61084C3.59919 9.82577 3.94764 9.82577 4.16257 9.61084L4.9407 8.83266L11.5564 15.4485C12.3542 16.2464 13.5202 16.4519 14.5076 16.065L15.0587 16.6161C15.3468 16.9042 15.755 16.9992 16.1223 16.901L17.3937 18.1725C17.6086 18.3874 17.957 18.3874 18.172 18.1725C18.3869 17.9575 18.3869 17.6091 18.172 17.3941L16.9004 16.1225C16.9983 15.7554 16.9033 15.3475 16.6153 15.0594L16.0643 14.5084C16.4512 13.5209 16.2458 12.3549 15.4479 11.557L8.83218 4.94108L9.61064 4.16262C9.82557 3.94769 9.82557 3.59924 9.61064 3.38431C9.39575 3.16937 9.04726 3.16938 8.83237 3.38431L7.27574 4.94094L5.33028 2.99541L5.71916 2.6065C5.93409 2.39158 5.93409 2.04311 5.71916 1.82819C5.50427 1.61326 5.15582 1.61326 4.94089 1.82819L1.8277 4.94146ZM6.60311 5.61357L4.65765 3.66806L3.66801 4.6577L5.61352 6.60326L6.60311 5.61357ZM8.15955 5.61376L5.61333 8.16003L7.70894 10.2556L10.2552 7.70937L8.15955 5.61376ZM8.48721 11.034L9.65468 12.2015L10.5387 11.3174C10.7537 11.1025 11.1021 11.1025 11.317 11.3174C11.532 11.5323 11.532 11.8808 11.317 12.0958L10.433 12.9798L11.2111 13.7579L12.0952 12.8738C12.3102 12.6588 12.6586 12.6588 12.8735 12.8738C13.0884 13.0887 13.0884 13.4372 12.8735 13.6521L11.9894 14.5362L12.2291 14.7759C12.7513 15.2982 13.5147 15.4325 14.161 15.1789L15.1782 14.1615C15.4319 13.5153 15.2976 12.7519 14.7753 12.2296L11.0334 8.48769L8.48721 11.034ZM15.9558 15.7471C15.9518 15.7419 15.9474 15.7369 15.9427 15.7321L15.5507 15.3401C15.5176 15.377 15.4833 15.4131 15.4479 15.4485C15.4124 15.484 15.3762 15.5183 15.3393 15.5514L15.7313 15.9434C15.7361 15.9482 15.7412 15.9527 15.7465 15.9567C15.7705 15.914 15.8007 15.8738 15.8371 15.8375C15.8733 15.8013 15.9133 15.7712 15.9558 15.7471Z" fill="white" />
                                            </svg>
                                        }

                                <span className="tt-capitalize color-white  " >

                                    {record?.category}

                                </span>
                                {record.state_abbreviation &&
                                    <button class="btn btn-secondary color-white fs-14  py-2">{record.state_abbreviation}</button>
                                }
                            </div>

                            <div className="record-card-body bg-body" >

                                {record?.category == "license" &&
                                    <>
                                        <div className="record-card-row" >
                                            <label className="color-white fs-14 ">{record?.identity}</label>

                                            <label className="color-lighter fs-12 ">License Number</label>

                                            <hr className={record?.category == "certification" ? "divider bg-yellow-bar" : (record?.category == "license" ? "divider bg-blue-bar" : "divider bg-red-bar")} />


                                        </div>

                                        <div className="record-card-row" >
                                            <label className="color-white fs-14 ">{record?.issued_by}</label>

                                            <label className="color-lighter fs-12 ">Issued By</label>

                                            <hr className={record?.category == "certification" ? "divider bg-yellow-bar" : (record?.category == "license" ? "divider bg-blue-bar" : "divider bg-red-bar")} />


                                        </div>

                                        <div className="record-card-row-wrap">
                                            <div className="record-card-row" >
                                                <label className="color-white fs-14 ">{record?.expiry_date}</label>

                                                <label className="color-lighter fs-12 ">Expiry</label>



                                            </div>
                                            <button className="btn btn-secondary color-white fs-12">
                                                {record?.days > 30 ?
                                                    <>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none">
                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.49984 12.8337C10.7215 12.8337 13.3332 10.222 13.3332 7.00033C13.3332 3.77866 10.7215 1.16699 7.49984 1.16699C4.27818 1.16699 1.6665 3.77866 1.6665 7.00033C1.6665 10.222 4.27818 12.8337 7.49984 12.8337ZM5.64314 6.33117L4.81818 7.15613L6.88058 9.21852L10.1804 5.91869L9.35545 5.09373L6.88058 7.56861L5.64314 6.33117Z" fill="#A1E312" />
                                                        </svg>
                                                        Active
                                                    </>
                                                    :
                                                    <>
                                                        {record?.days > 0 ?
                                                            <>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none">
                                                                    <g clip-path="url(#clip0_6133_22800)">
                                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.93384 1.16699H6.12068L0.791504 10.3974L2.19809 12.8337H12.8564L14.263 10.3974L8.93384 1.16699ZM8.11062 4.66699V8.16699H6.94395V4.66699H8.11062ZM8.11062 9.33366L8.11063 10.5003L6.94396 10.5003L6.94395 9.33366L8.11062 9.33366Z" fill="#FFDE1E" />
                                                                    </g>
                                                                    <defs>
                                                                        <clipPath id="clip0_6133_22800">
                                                                            <rect width="14" height="14" fill="white" transform="translate(0.5)" />
                                                                        </clipPath>
                                                                    </defs>
                                                                </svg>

                                                                Expires Soon
                                                            </>
                                                            :
                                                            <>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none">
                                                                    <g clip-path="url(#clip0_6133_22914)">
                                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.93384 1.16699H6.12068L0.791504 10.3974L2.19809 12.8337H12.8564L14.263 10.3974L8.93384 1.16699ZM8.11062 4.66699V8.16699H6.94395V4.66699H8.11062ZM8.11062 9.33366L8.11063 10.5003L6.94396 10.5003L6.94395 9.33366L8.11062 9.33366Z" fill="#FF7373" />
                                                                    </g>
                                                                    <defs>
                                                                        <clipPath id="clip0_6133_22914">
                                                                            <rect width="14" height="14" fill="white" transform="translate(0.5)" />
                                                                        </clipPath>
                                                                    </defs>
                                                                </svg>
                                                                Expired

                                                            </>
                                                        }
                                                    </>

                                                }
                                            </button>
                                        </div>
                                    </>
                                }




                                {record?.category == "certification" &&
                                    <>
                                        <div className="record-card-row" >
                                            <label className="color-white fs-14 ">{record?.identity}</label>

                                            <label className="color-lighter fs-12 ">Certification Number</label>

                                            <hr className={record?.category == "certification" ? "divider bg-yellow-bar" : (record?.category == "license" ? "divider bg-blue-bar" : "divider bg-red-bar")} />


                                        </div>

                                        <div className="record-card-row" >
                                            <label className="color-white fs-14 ">{record?.issued_by}</label>

                                            <label className="color-lighter fs-12 ">Issued By</label>

                                            <hr className={record?.category == "certification" ? "divider bg-yellow-bar" : (record?.category == "license" ? "divider bg-blue-bar" : "divider bg-red-bar")} />


                                        </div>

                                        <div className="record-card-row-wrap">
                                            <div className="record-card-row" >
                                                <label className="color-white fs-14 ">{record?.expiry_date}</label>

                                                <label className="color-lighter fs-12 ">Expiry</label>



                                            </div>
                                            <button className="btn btn-secondary color-white fs-12">
                                                {record?.days > 30 ?
                                                    <>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none">
                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.49984 12.8337C10.7215 12.8337 13.3332 10.222 13.3332 7.00033C13.3332 3.77866 10.7215 1.16699 7.49984 1.16699C4.27818 1.16699 1.6665 3.77866 1.6665 7.00033C1.6665 10.222 4.27818 12.8337 7.49984 12.8337ZM5.64314 6.33117L4.81818 7.15613L6.88058 9.21852L10.1804 5.91869L9.35545 5.09373L6.88058 7.56861L5.64314 6.33117Z" fill="#A1E312" />
                                                        </svg>
                                                        Active
                                                    </>
                                                    :
                                                    <>
                                                        {record?.days > 0 ?
                                                            <>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none">
                                                                    <g clip-path="url(#clip0_6133_22800)">
                                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.93384 1.16699H6.12068L0.791504 10.3974L2.19809 12.8337H12.8564L14.263 10.3974L8.93384 1.16699ZM8.11062 4.66699V8.16699H6.94395V4.66699H8.11062ZM8.11062 9.33366L8.11063 10.5003L6.94396 10.5003L6.94395 9.33366L8.11062 9.33366Z" fill="#FFDE1E" />
                                                                    </g>
                                                                    <defs>
                                                                        <clipPath id="clip0_6133_22800">
                                                                            <rect width="14" height="14" fill="white" transform="translate(0.5)" />
                                                                        </clipPath>
                                                                    </defs>
                                                                </svg>

                                                                Expires Soon
                                                            </>
                                                            :
                                                            <>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none">
                                                                    <g clip-path="url(#clip0_6133_22914)">
                                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.93384 1.16699H6.12068L0.791504 10.3974L2.19809 12.8337H12.8564L14.263 10.3974L8.93384 1.16699ZM8.11062 4.66699V8.16699H6.94395V4.66699H8.11062ZM8.11062 9.33366L8.11063 10.5003L6.94396 10.5003L6.94395 9.33366L8.11062 9.33366Z" fill="#FF7373" />
                                                                    </g>
                                                                    <defs>
                                                                        <clipPath id="clip0_6133_22914">
                                                                            <rect width="14" height="14" fill="white" transform="translate(0.5)" />
                                                                        </clipPath>
                                                                    </defs>
                                                                </svg>
                                                                Expired

                                                            </>
                                                        }
                                                    </>

                                                }
                                            </button>
                                        </div>
                                    </>
                                }





                                {record?.category == "vaccine" &&
                                    <>
                                        <div className="record-card-row" >
                                            <label className="color-white fs-14 ">{record?.identity}</label>

                                            <label className="color-lighter fs-12 ">Patient</label>

                                            <hr className={record?.category == "certification" ? "divider bg-yellow-bar" : (record?.category == "license" ? "divider bg-blue-bar" : "divider bg-red-bar")} />


                                        </div>

                                        <div className="record-card-row" >
                                            <label className="color-white fs-14 ">{record?.issued_by}</label>

                                            <label className="color-lighter fs-12 ">Issued By</label>

                                            <hr className={record?.category == "certification" ? "divider bg-yellow-bar" : (record?.category == "license" ? "divider bg-blue-bar" : "divider bg-red-bar")} />


                                        </div>

                                        <div className="record-card-row-wrap">
                                            <div className="record-card-row" >
                                                <label className="color-white fs-14 ">{record?.notes}</label>

                                                <label className="color-lighter fs-12 ">Type</label>



                                            </div>
                                            <button className="btn btn-secondary color-white fs-12">
                                                {record?.days > 30 ?
                                                    <>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none">
                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.49984 12.8337C10.7215 12.8337 13.3332 10.222 13.3332 7.00033C13.3332 3.77866 10.7215 1.16699 7.49984 1.16699C4.27818 1.16699 1.6665 3.77866 1.6665 7.00033C1.6665 10.222 4.27818 12.8337 7.49984 12.8337ZM5.64314 6.33117L4.81818 7.15613L6.88058 9.21852L10.1804 5.91869L9.35545 5.09373L6.88058 7.56861L5.64314 6.33117Z" fill="#A1E312" />
                                                        </svg>
                                                        Active
                                                    </>
                                                    :
                                                    <>
                                                        {record?.days > 0 ?
                                                            <>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none">
                                                                    <g clip-path="url(#clip0_6133_22800)">
                                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.93384 1.16699H6.12068L0.791504 10.3974L2.19809 12.8337H12.8564L14.263 10.3974L8.93384 1.16699ZM8.11062 4.66699V8.16699H6.94395V4.66699H8.11062ZM8.11062 9.33366L8.11063 10.5003L6.94396 10.5003L6.94395 9.33366L8.11062 9.33366Z" fill="#FFDE1E" />
                                                                    </g>
                                                                    <defs>
                                                                        <clipPath id="clip0_6133_22800">
                                                                            <rect width="14" height="14" fill="white" transform="translate(0.5)" />
                                                                        </clipPath>
                                                                    </defs>
                                                                </svg>

                                                                Expires Soon
                                                            </>
                                                            :
                                                            <>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none">
                                                                    <g clip-path="url(#clip0_6133_22914)">
                                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.93384 1.16699H6.12068L0.791504 10.3974L2.19809 12.8337H12.8564L14.263 10.3974L8.93384 1.16699ZM8.11062 4.66699V8.16699H6.94395V4.66699H8.11062ZM8.11062 9.33366L8.11063 10.5003L6.94396 10.5003L6.94395 9.33366L8.11062 9.33366Z" fill="#FF7373" />
                                                                    </g>
                                                                    <defs>
                                                                        <clipPath id="clip0_6133_22914">
                                                                            <rect width="14" height="14" fill="white" transform="translate(0.5)" />
                                                                        </clipPath>
                                                                    </defs>
                                                                </svg>
                                                                Expired

                                                            </>
                                                        }
                                                    </>

                                                }
                                            </button>
                                        </div>
                                    </>
                                }


                            </div>
                        </div>
                    }

                </div>




            </div>
            <div className="form-action">

                <div className="action-bar ">

                    <div className="button-box">

                        <button className="btn btn-secondary" type="button" onClick={backToRecords}>Cancel</button>
                        <button className="btn btn-danger" onClick={removeRecord} disabled={isBtn}>
                            {isBtn ? <Loading size={'20px'} /> : 'Delete Record'}</button>

                    </div>
                </div>

            </div>








        </>


    );
};

export default Record;